export const AuthConstants = {
  access_token: 'ACCESS_TOKEN',
};
